import {
  Outlet,
  useLoaderData
} from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectIsLoggedIn,
} from "../../../services/authorization/slices";
import Unauthorized from "../../../Authentication/components/Unauthorized";

function ProtectedRoute() {
  const loaderData = useLoaderData();
  const { isAuthorized } = loaderData || {};
  const isLoggedIn = useSelector(selectIsLoggedIn);

  if (isAuthorized) {
    return (
      <Outlet
        context={{
          isLoggedIn,
          isAuthorized,
        }}
      />
    );
  }
  return <Unauthorized />;
}

export default ProtectedRoute;
